export const enabledExcessRewardsCampaigns = [
  '0x5f7d276edfd29f966584dc63f8dfe729883bfba3', // dogu-test-rinkeby
  '0x2ef40f9b2a92ed88199c91f9c9f8fd9e8067da2f', // Rite-bsc
  '0x0203db99a8be7d6fc1e358ef62488b3c7a276d54', // Rite-bsc
];
